import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { OverlayModule } from '@angular/cdk/overlay';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSidenavModule } from '@angular/material/sidenav';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        MatTableModule,
        MatNativeDateModule,
        MatSortModule,
        MatPaginatorModule,
        MatToolbarModule,
        MatCardModule,
        MatGridListModule,
        MatButtonToggleModule,
        MatRadioModule,
        MatSelectModule,
        MatIconModule,
        MatDatepickerModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        MatTabsModule,
        MatListModule,
        MatProgressBarModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatStepperModule,
        MatTooltipModule,
        MatDialogModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatSnackBarModule,
        MatChipsModule,
        MatCardModule,
        MatFormFieldModule,
        MatOptionModule,
        DragDropModule,
        ScrollingModule,
        OverlayModule,
        MatSidenavModule
    ],
    exports: [
        CommonModule,
        MatTableModule,
        MatNativeDateModule,
        MatSortModule,
        MatPaginatorModule,
        MatToolbarModule,
        MatCardModule,
        MatGridListModule,
        MatButtonToggleModule,
        MatRadioModule,
        MatSelectModule,
        MatIconModule,
        MatDatepickerModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        MatTabsModule,
        MatListModule,
        MatProgressBarModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatStepperModule,
        MatTooltipModule,
        MatDialogModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatSnackBarModule,
        MatChipsModule,
        DragDropModule,
        ScrollingModule,
        OverlayModule,
        MatSidenavModule
    ],
})
export class MaterialModule {
}
